import { Dialog, DialogContent } from '@mui/material'

import { HeaderBulkImport } from './components/HeaderBulkImport'
import { StepsContainerBulkImport } from './components/steps/StepsContainerBulkImport'
import { NavigationBulkImport } from './components/NavigationBulkImport'
import { useBulkImportStore } from './hooks/useBulkImportStore'
import { BulkEditModalImportBuilder } from './components/steps/ThirdStepBulkImport/BulkEditModalImportBuilder'
import { type SettingsBulkImport } from './store/bulk-import.store.types'

import { type CardActivityWithId } from '@/models/card-activity/card-activity.model'

export function BulkImportModal({
  onCardsCreated,
}: {
  onCardsCreated: (props: { cards: CardActivityWithId[]; settings: SettingsBulkImport }) => Promise<void>
}) {
  const open = useBulkImportStore(store => store.open)

  return (
    <Dialog fullScreen open={open}>
      <DialogContent
        sx={{
          paddingX: '0',
          paddingY: '0',
          bgcolor: '#F9FAFB',
          height: '100vh',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          gap: '8px',
        }}
      >
        <HeaderBulkImport />
        <StepsContainerBulkImport />
        <NavigationBulkImport onCardsCreated={onCardsCreated} />
        <BulkEditModalImportBuilder />
      </DialogContent>
    </Dialog>
  )
}
